import {getCodeVerifierFromAuthorizationRequest} from '@ef/oauth-js-client';
import {IftUser} from './user';
import {NavigateFunction} from "react-router/dist/lib/hooks";
import oauth from './oauth';
import { parseJwt } from './oauth';
import env from './environment';

export type StartAuthenticationFlowFunction = () => Promise<void>;
export type HandleLoginFunction = (user: IftUser, navigate: NavigateFunction) => void;
export type FinishAuthenticationFlowFunction = () => Promise<IftUser>;

export async function startAuthenticationFlow(): Promise<void> {
  console.debug('[App] (OAuth) Beginning authorization');
  await oauth.fetchAuthorizationServiceConfiguration();
  oauth.authorize(env.redirectUri, env.scope);
}

export function finishAuthenticationFlow(): Promise<IftUser> {
  console.debug('(OAuth) Finishing authorization');

  return new Promise ((resolve, reject) => {
      oauth.setAuthorizationListener(async (request, response, error) => {
          if (error) {
              reject(new Error('Authorization request failed'));
              return;
          }
          if (response) {
              try {
                  await oauth.fetchAuthorizationServiceConfiguration();
                  const codeVerifier = getCodeVerifierFromAuthorizationRequest(request);
                  const tokenResponse = await oauth.authorizationCodeExchange(response.code, env.redirectUri, codeVerifier, env.audience);
                  const {sub, groups, exp} = parseJwt(tokenResponse.accessToken);
                  
                  if (groups && groups.includes(env.pingGroup)) {
                    const tokenObj = {
                      userName: sub,
                      groups: groups,
                      accessToken: tokenResponse.accessToken,
                      exp: exp
                    }
                    resolve(tokenObj);
                  } else {
                    console.log('(OAuth) Authorization token is missing required group claim. You are not authorized to use this application');
                    reject(new Error('Authorization token is missing required group claim. You are not authorized to use this application'));
                    return;
                  }
              } catch (tokenError) {
                  console.log('(OAuth) Authorization code exchange failed', tokenError);
                  reject(new Error('Authorization code exchange failed'));
                  return;
              }
          } else {
              console.log('(OAuth) missing Authorization response');
              reject(new Error('Authorization missing response'));
              return;
          }
      });

      // this calls the listener to complete the auth flow
      oauth.checkForAuthorizationResponse();
  });
}
